import { useSelector } from 'react-redux';

import { getCurrentBasicEntity } from '@neptune/current-entity-business-logic';
import { getEntityArchived, getEntityDisplayName } from '@neptune/shared/entity-domain';
import { createCurrentRouteParamSelector } from '@neptune/shared/routing-business-logic';

import { getIsExperimentHeadFromAttributes } from 'domain/experiment/attribute';
import { AppState } from 'state/types';

const runIdentificationKeySelector = createCurrentRouteParamSelector('runIdentificationKey');

const getCurrentRunName = (state: AppState): string | undefined => {
  const runIdentificationKey: string = runIdentificationKeySelector(state) || '';

  const currentBasicEntity = getCurrentBasicEntity(state);

  if (!currentBasicEntity) {
    return undefined;
  }

  return getEntityDisplayName(currentBasicEntity, runIdentificationKey);
};

export const useCurrentRunIdentity = (): {
  currentRunName: string | undefined;
  currentRunIdentificationKey: string | undefined;
  isExperimentHead: boolean | undefined;
  isArchived: boolean | null;
} => {
  const currentBasicEntity = useSelector(getCurrentBasicEntity);
  const currentRunName = useSelector(getCurrentRunName);
  const currentRunIdentificationKey = useSelector(runIdentificationKeySelector);
  const isExperimentHead = currentBasicEntity
    ? getIsExperimentHeadFromAttributes(currentBasicEntity.attributes)
    : undefined;
  const isArchived = currentBasicEntity ? getEntityArchived(currentBasicEntity) : null;

  return {
    currentRunName,
    currentRunIdentificationKey,
    isExperimentHead,
    isArchived,
  };
};
